import type { createListenerMiddleware } from '@reduxjs/toolkit';
import { MS_IN_MINUTE, showToast } from 'BreetHelpers';

import { clearCredentials } from '../slices/app/authCredentialsSlice';
import type { AppDispatch, RootState } from '../store';

export const CREDENTIALS_TTL_MS = 5 * MS_IN_MINUTE;

export function authCredentialsListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startAppListening = mw.startListening.withTypes<RootState, AppDispatch>();

	startAppListening({
		predicate: (action) => action.type === 'authCredentials/setCredentials',
		effect: async (_, api) => {
			api.cancelActiveListeners();

			const result = await api.condition((action) => action.type === 'authCredentials/clearCredentials', CREDENTIALS_TTL_MS);

			if (!result) {
				const state = api.getState();
				if (state.authCredentials.credentials) {
					api.dispatch(clearCredentials());

					showToast('error', 'Your session expired. Please log in again.');
					const { default: router } = await import('../../router');
					router.navigate('/login', { replace: true }).catch(console.error);
				}
			}
		},
	});

	startAppListening({
		predicate: (action) => action.type === 'authCredentials/clearCredentials',
		effect: (_, api) => {
			api.cancelActiveListeners();
		},
	});
}
